export function Logo({ size = 72 }: { size?: number }) {
  return (
    <svg
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: size, height: size }}
    >
      <rect x="2" y="4" width="28" height="20" rx="4" fill="#444" />
      <rect x="5" y="7" width="22" height="14" rx="2" fill="#0a1a0a" />
      <ellipse
        cx="16"
        cy="14"
        rx="10"
        ry="6"
        fill="#4f4"
        opacity="0.15"
        style={{ filter: 'blur(3px)' }}
      />
      <polygon points="13,10 13,18 21,14" fill="#2a2" />
      <rect x="12" y="24" width="8" height="2" rx="1" fill="#444" />
      <rect x="9" y="26" width="14" height="2" rx="1" fill="#444" />
    </svg>
  );
}
